<ng-container *ngIf="viewMode === ViewModes.Grid">
  <div
    infiniteScroll
    [infiniteScrollDistance]="5"
    [infiniteScrollThrottle]="50"
    [infiniteScrollDisabled]="isMaxProducts || isLastPage || isEmpty"
    (scrolled)="scrollPage(model?.pagination?.currentPage + 1)"
  >
    <div class="row">
      <eb-product-grid-item
        *ngFor="let product of getProducts(model)"
        [product]="product"
        [facets]="model?.facets"
        class="col-12 col-md-6 col-xl-4 eb-product-grid"
      ></eb-product-grid-item>
    </div>
  </div>
  <div *ngIf="appendProducts" class="spinner-container">
    <eb-spinner></eb-spinner>
  </div>
</ng-container>
